import { render, staticRenderFns } from "./welcomeLanguageEdit.vue?vue&type=template&id=6303bf91&scoped=true"
import script from "./welcomeLanguageEdit.vue?vue&type=script&lang=js"
export * from "./welcomeLanguageEdit.vue?vue&type=script&lang=js"
import style0 from "./welcomeLanguageEdit.vue?vue&type=style&index=0&id=6303bf91&prod&lang=css"
import style1 from "./welcomeLanguageEdit.vue?vue&type=style&index=1&id=6303bf91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6303bf91",
  null
  
)

export default component.exports